<template>
  <div
    class="flex w-full overflow-hidden rounded-md bg-gray-200"
    :class="{
      'h-1-25': small,
      'h-5': !small,
    }"
  >
    <div
      v-if="manual"
      class="flex h-full items-center justify-start overflow-hidden border-r border-white bg-primary"
      :style="{ width: `${(manualPoints / total) * 100}%` }"
    ></div>
    <div
      v-for="(category, index) in categoriesWithWidth"
      :key="index"
      data-cy="category-result"
      class="flex h-full items-center justify-start overflow-hidden"
      :class="[
        { 'border-r border-white': parseFloat(category.width) > 0 },
        { 'opacity-80 grayscale': knockedOut },
      ]"
      :style="{
        width: category.width,
        backgroundColor:
          'color' in category && category.color
            ? category.color
            : SCORECARD_COLOR_SWATCHES[index % SCORECARD_COLOR_SWATCHES.length],
      }"
    >
      <span
        v-if="showPercentage && parseFloat(category.width) > 0"
        class="flex grow items-stretch justify-center"
        :class="getTextClass(category.color || '')"
        :title="formatPercentage(category.width) ?? undefined"
      >
        {{ formatPercentage(category.width) }}
      </span>
    </div>
    <div
      v-if="!started && !small"
      class="flex h-full w-full items-center justify-center bg-gray-200 font-semibold uppercase"
    >
      {{ $t("SCORECARDS.NOT_STARTED_YET") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getTextClass } from "@/helpers/UI";
import { SCORECARD_COLOR_SWATCHES } from "@/helpers/constants";
import { formatPercentage } from "@/helpers/formatting";

import type {
  IScorecardContentCategory,
  ScorecardGroupWeightedPointsResults,
} from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  categories: {
    type: Array as PropType<IScorecardContentCategory[]>,
    default: () => [],
  },
  weightedPoints: {
    type: Array as PropType<ScorecardGroupWeightedPointsResults[]>,
    default: () => [],
  },
  total: {
    type: Number,
    default: 0,
  },
  showPercentage: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  isGroup: {
    type: Boolean,
    default: false,
  },
  started: {
    type: Boolean,
    default: false,
  },
  knockedOut: {
    type: Boolean,
    default: false,
  },
  manual: {
    type: Boolean,
    default: false,
  },
  manualPoints: {
    type: Number,
    default: 0,
  },
});

const categoriesWithWidth = computed(() =>
  props.isGroup
    ? props.weightedPoints?.map((cat) => {
        const width = props.total
          ? (cat.weighted_points / props.total) * 100
          : 0;
        return {
          ...cat,
          width: `${width}%`,
          color: "",
        };
      })
    : props.categories?.map((cat) => {
        const width = props.total
          ? Math.round(
              ((cat.backup_applied
                ? cat.backup_applied.calculated_points || 0
                : cat.calculated_points || 0) /
                props.total) *
                100
            )
          : 0;
        return {
          ...cat,
          width: `${width}%`,
        };
      })
);
</script>
